module.exports = __webpack_public_path__ + "static/media/success-green-40x40.6724e9d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success-green-40x40.svg
// module id = 1323
// module chunks = 1